import React from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import cyan from '@material-ui/core/colors/cyan';

class SubtitleSelector extends React.Component {
  state = {
    open: false,
    anchorEl: null,
  };
  handleClick = (e) => {
    e.preventDefault();
    this.props.onOverlayFixed(true);
    this.props.onOpenMenu(true);
    this.setState({
      open: true,
      anchorEl: e.currentTarget
    });
  };
  handleClose = (e) => {
    this.setState({
      open: false,
      anchorEl: null
    });
    this.props.onOverlayFixed(false);
    this.props.onOpenMenu(false);
  };
  handleChange = (event, index, value) => {
    this.setState({value});
  }
  render = () => {
    const overlay = this.props.overlay;
    if (!overlay) {
      return (<div/>);
    }
    const { anchorEl } = this.state;
    return (
      <div
        id="subtitle-selector"
        hidden={this.props.isFullscreen}
      >
        <Button
          aria-owns={anchorEl ? 'subtitle-menu' : undefined}
          aria-haspopup="true"
          style={{color: 'white', minWidth: '36px', backgroundColor:'rgba(0, 0, 0, 0.6)'}}
          onClick={this.handleClick}
        >
          字幕
        </Button>
        <Menu
          id="subtitle-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          <MenuItem
            style={(this.props.currentSubtitleMode === "showing" || this.props.currentSubtitleMode === undefined) ? {backgroundColor: cyan[400]} : {}}
            onClick={_ => this.props.onChangeSubtitle("showing")}
          >ON</MenuItem>
          <MenuItem
            style={(this.props.currentSubtitleMode  === "outside") ? {backgroundColor: cyan[400]} : {}}
            onClick={_ => this.props.onChangeSubtitle("outside")}
          >ON(画面外)</MenuItem>
          <MenuItem
            style={(this.props.currentSubtitleMode === "hidden") ? {backgroundColor: cyan[400]} : {}}
            onClick={_ => this.props.onChangeSubtitle("hidden")}
          >OFF</MenuItem>
        </Menu>
      </div>
    );
  }
};
export default SubtitleSelector;



// WEBPACK FOOTER //
// ./src/components/SubtitleSelector.js